import { Injectable } from '@angular/core';
import type { TBookAlias } from '@shared/jp/product';
import {
  BOOK_ALIAS_FROEBELKAN,
  BOOK_ALIAS_FROEBELKAN_ALPHABET_TRAIN,
  BOOK_ALIAS_FROEBELKAN_MAINICHI_KINENBI,
  INPUT_NAME_FKMK_COVER_COLOR,
  INPUT_NAME_KUN_CHAN,
} from '@shared/jp/product';
import type { ICommonBookData } from '@shared/jp/models';
import { LoaderService } from '@studiobuki/web-core/lib/loader';
import {
  INPUT_NAME_AGE_TO_BE,
  INPUT_NAME_GLASSES,
  INPUT_NAME_HAIR_COLOR,
  INPUT_NAME_HAIR_STYLE,
  INPUT_NAME_KIDS_BIRTHDAY,
  INPUT_NAME_KIDS_NAME,
  INPUT_NAME_SKIN_COLOR,
  INPUT_NAME_PHOTO,
} from '@shared/common/product';
import { BookFroebelkanService } from 'src/app/pages/book-page/pages/book-froebelkan-page/book-froebelkan.service';
import { BookAlphabetTrainService } from 'src/app/pages/book-page/pages/book-alphabet-train/book-alphabet-train.service';
import { BookMainichiKinenbiService } from 'src/app/pages/book-page/pages/book-mainichi-kinenbi/book-mainichi-kinenbi.service';

@Injectable({
  providedIn: 'root',
})
export class BooksService {
  constructor(
    private _bookFroebelkanService: BookFroebelkanService,
    private _bookAlphabetTrainService: BookAlphabetTrainService,
    private _bookMainichiKinenbiService: BookMainichiKinenbiService,
    private _loader: LoaderService,
  ) {}

  async createBookByAlias(
    alias: TBookAlias,
    /** IBookInputNameToValueMap */
    bookCreateData: any,
    common?: Partial<ICommonBookData>,
  ) {
    this._loader.show();

    try {
      switch (alias) {
        case BOOK_ALIAS_FROEBELKAN:
          return await this._bookFroebelkanService.createBook(
            {
              ageToBe: bookCreateData[INPUT_NAME_AGE_TO_BE],
              birthDate: bookCreateData[INPUT_NAME_KIDS_BIRTHDAY],
              heroName: bookCreateData[INPUT_NAME_KIDS_NAME],
              kunChan: bookCreateData[INPUT_NAME_KUN_CHAN],
            },
            common,
          );
        case BOOK_ALIAS_FROEBELKAN_ALPHABET_TRAIN:
          return await this._bookAlphabetTrainService.createBook(
            {
              heroName: bookCreateData[INPUT_NAME_KIDS_NAME],
              kunChan: bookCreateData[INPUT_NAME_KUN_CHAN],
              hairColor: bookCreateData[INPUT_NAME_HAIR_COLOR],
              hairStyle: bookCreateData[INPUT_NAME_HAIR_STYLE],
              skinColor: bookCreateData[INPUT_NAME_SKIN_COLOR],
              glasses: bookCreateData[INPUT_NAME_GLASSES],
              vehicle: bookCreateData.vehicle,
            },
            common,
          );
        case BOOK_ALIAS_FROEBELKAN_MAINICHI_KINENBI:
          return await this._bookMainichiKinenbiService.createBook(
            {
              heroName: bookCreateData[INPUT_NAME_KIDS_NAME],
              kunChan: bookCreateData[INPUT_NAME_KUN_CHAN],
              coverColor: bookCreateData[INPUT_NAME_FKMK_COVER_COLOR],
              photo: bookCreateData[INPUT_NAME_PHOTO],
            },
            common,
          );
        default:
          throw new Error(`Unexpected alias "${alias}"`);
      }
    } catch (e: any) {
      alert(`Something went wrong. ${'message' in e ? e.message : e}`);
      throw e;
    } finally {
      this._loader.hide();
    }
  }
}
